import { Controller } from "@hotwired/stimulus"
import AirDatepicker from "air-datepicker"
import localeFr from "air-datepicker/locale/fr"
import "air-datepicker/air-datepicker.css"

export default class extends Controller {
  static targets = ["calendar"]
  static values = {
    date: String,
    baseUrl: String,
    bookableType: String,
    sunbedType: String,
    tagIds: String
  }

  connect() {
    this.initCalendar()
  }

  disconnect() {
    if (this.datepickerInstance) {
      this.datepickerInstance.destroy()
    }
  }

  initCalendar() {
    const defaultDate = this.dateValue ? new Date(this.dateValue) : new Date()
    
    this.datepickerInstance = new AirDatepicker(this.calendarTarget, {
      inline: true,
      locale: localeFr,
      selectedDates: [defaultDate],
      dateFormat: "yyyy-MM-dd",
      onSelect: ({ date, formattedDate }) => {
        if (date && formattedDate) {
          this.navigateToDate(formattedDate)
        }
      }
    })
  }

  navigateToDate(dateStr) {
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("date", dateStr)
    
    if (this.sunbedTypeValue) {
      url.searchParams.set("sunbed_type", this.sunbedTypeValue)
    }
    
    if (this.tagIdsValue) {
      url.searchParams.set("tag_ids", this.tagIdsValue)
    }
    
    // Navigation via Turbo
    Turbo.visit(url.toString())
  }

  // Méthode pour naviguer vers aujourd'hui
  goToToday() {
    const today = new Date().toISOString().split('T')[0]
    this.navigateToDate(today)
  }

  // Méthode pour naviguer au jour précédent
  previousDay() {
    const currentDate = new Date(this.dateValue)
    currentDate.setDate(currentDate.getDate() - 1)
    const dateStr = currentDate.toISOString().split('T')[0]
    this.navigateToDate(dateStr)
  }

  // Méthode pour naviguer au jour suivant
  nextDay() {
    const currentDate = new Date(this.dateValue)
    currentDate.setDate(currentDate.getDate() + 1)
    const dateStr = currentDate.toISOString().split('T')[0]
    this.navigateToDate(dateStr)
  }
}
